import { render, staticRenderFns } from "./QrStatusFormatter.vue?vue&type=template&id=08352a15&"
import script from "./QrStatusFormatter.vue?vue&type=script&lang=js&"
export * from "./QrStatusFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports